




























/* eslint no-undef: 0 */

import {Component, Vue} from "vue-property-decorator";

@Component
export default class ChannelSelectModal extends Vue
{
  private channels: gapi.client.youtube.Channel[] = [];
  private callback: ((canceled: false, channel: gapi.client.youtube.Channel) => unknown)| null;
  private show = false;

  // eslint-disable-next-line no-undef
  public setChannelsToSelect(channels: gapi.client.youtube.Channel[],
                             // eslint-disable-next-line no-undef
                             callback: (canceled: false, channel: gapi.client.youtube.Channel) => unknown): void {
    console.log(channels);
    this.channels = channels;
    this.callback = callback;
    this.show = true;
  }
}
